/* eslint-disable class-methods-use-this */
/**
 * Toggle Module
 */

class MenuToggle {
  constructor() {
    // Show/hide menu
    const headerMenu = $('#menu');
    const headerToggle = $('#toggle');

    headerToggle.on('click', () => {
      headerMenu.toggleClass('-open');
      headerToggle.toggleClass('-open');
      $('body').toggleClass('-block');
    });
  }

}

export default MenuToggle;

